import { createModelSchema, primitive, object } from 'serializr';

import { optional } from '@vromo/models';

import { User } from '@vromo/models';

export class DispatchAudit {
    type?: 'driver' | 'offer' | 'dispatcher' | 'auto';
    user: User | null = null;
}

createModelSchema(DispatchAudit, {
    type: primitive(),
    user: optional(object(User))
});
